import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-baseline gap-x-0" }
const _hoisted_2 = { class: "w-full flex justify-center" }
const _hoisted_3 = { class: "cursor-pointer" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-5" }

import ConnectionChecker from '@/components/ConnectionChecker.vue';
import DocPreferences from '@/components/RezTabDoc/DocPreferences/index.vue';
import ShortkeysGuid from './ShortkeysGuid.vue';
import { useStore } from 'vuex';
import Logo from './utils/Logo.vue';
import { useDoc } from '@/composables/useDoc';
import RezTabFile from '@/store/modules/RezTabFile';
import { useToast } from 'vuestic-ui/web-components';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import { DocumentArrowUpIcon, CodeBracketSquareIcon } from '@heroicons/vue/24/solid';
import DevTest from './utils/DevTest.vue';
import type {State} from '@/store'

export default /*@__PURE__*/_defineComponent({
  __name: 'PanelLayout',
  setup(__props) {


const store = useStore<State>();
const isSaving = ref(false)
const toast = useToast();
const router = useRouter();
const saveButtonIconName = ref('save')
async function save() {
  isSaving.value = true
  const doc = useDoc();
  let wannaRefreshThepage = !doc.id;
  const result = await doc.save();
  toast.init({
    color: 'success', message: 'Saved Successfully.',
    position: 'bottom-right'
  })



  doc.id = result.id
  doc.unfreeze();
  isSaving.value = false
  if (wannaRefreshThepage) {
    return router.push({ path: '/doc/' + doc.id }), 1000
  } else return doc.unfreeze();

}


async function logout() {
  const result = await store.dispatch('logout');
  toast.init({
    message: result.data.message,
    color: 'success',
    position: 'bottom-right'
  })
  router.push('/Login')
}


return (_ctx: any,_cache: any) => {
  const _component_VaNavbarItem = _resolveComponent("VaNavbarItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_VaNavbar = _resolveComponent("VaNavbar")!
  const _component_va_layout = _resolveComponent("va-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_va_layout, null, {
        top: _withCtx(() => [
          _createVNode(_component_VaNavbar, {
            color: "primary",
            class: "items-center"
          }, {
            left: _withCtx(() => [
              _createVNode(_component_VaNavbarItem, null, {
                default: _withCtx(() => [
                  _createVNode(Logo)
                ]),
                _: 1
              })
            ]),
            center: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/doc" }, {
                default: _withCtx(() => [
                  _createVNode(_component_VaNavbarItem, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(store).state.currentUser?.name) + " Docs ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            right: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_VaNavbarItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: '/import' }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DocumentArrowUpIcon), { class: "fill-white w-8" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_VaNavbarItem, { class: "self-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_button, {
                      class: "p-0 flex justify-center w-10",
                      onClick: save
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, [
                          (isSaving.value)
                            ? (_openBlock(), _createBlock(_component_va_inner_loading, {
                                key: 0,
                                color: "white",
                                loading: ""
                              }))
                            : (_openBlock(), _createBlock(_component_va_icon, {
                                key: 1,
                                name: "save",
                                size: "1.8rem"
                              }))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_VaNavbarItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_button, {
                      onClick: _cache[0] || (_cache[0] = () => _unref(useDoc)().generateAndDownloadMei())
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("img", {
                            src: `${_unref(store).state.baseUrl}logos/mei-logo-simple-dark.png`,
                            class: "w-14",
                            alt: "MEI LOGO"
                          }, null, 8, _hoisted_4)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_VaNavbarItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_button, null, {
                      default: _withCtx(() => [
                        _createVNode(DocPreferences)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_VaNavbarItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_button, null, {
                      default: _withCtx(() => [
                        _createVNode(ShortkeysGuid)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_VaNavbarItem, { class: "self-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_button, { onClick: logout }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_icon, {
                          name: "logout",
                          size: "large"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_VaNavbarItem, { class: "self-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      class: "h-full",
                      to: "/doc/new",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_icon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})